import React from "react";

export const TodoBottomSheetNavigatorContext = React.createContext<{
  openTodoMoveToCategory: (todoId: string) => void;
  onShowFile: (fileId: string) => void;
  openProductDetail: (productId: string) => void;
}>({
  openTodoMoveToCategory: () => {},
  onShowFile: () => {},
  openProductDetail: () => {},
});
